<template>
  <div class="fora" v-if="colegiado">
    <div class="topo-header centro so-tela">

      <div style="display: flex; align-items: center;">
        <botao-voltar class="voltar" nomeRota="Colegiado" />
        <h1>Visualizar Colegiados</h1>
      </div>
      
      <!-- Lado Direito (Ações): Baixar PDF, Editar e Excluir -->
      <div class="acoes-topo">
        
        <!-- 1. Botão Baixar PDF (agora o primeiro da lista) -->
        <BaixarPdf
          :colegiado="colegiado"
          :mandatos="mandatos || []"
          :selected-orgao="orgaoParaPdf"
        />
        
        <!-- 2 e 3. Botões Editar e Excluir (protegidos pela permissão) -->
        <template v-if="permissoes.pode_editar">
          <a :href="'/colegiados/colegiado-edit/' + colegiado.id" style="text-decoration: none;">
            <button id="botao-editar" class="btn-acao btn-editar">Editar</button>
          </a>
          <button id="botao-excluir" class="btn-acao btn-excluir" @click.prevent="modalExclusaoVisivel = true">Excluir</button>
        </template>

      </div>

    </div>
   
    <div class="form centro">
      
      <!-- O CONTAINER DAS ABAS -->
      <div class="container-abas-topo so-tela">
        <nav class="abas">
          <button
            type="button"
            class="aba"
            :class="{ ativa: abaAtiva === 'informacoes' }"
            @click="abaAtiva = 'informacoes'"
          >
            Informações Gerais
          </button>
          <button
            type="button"
            class="aba"
            :class="{ ativa: abaAtiva === 'mandatos' }"
            @click="abaAtiva = 'mandatos'"
          >
            Mandatos
          </button>
        </nav>
      </div>

      <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />

      <div class="conteudo-abas">        
        <!-- GUIA 1: INFORMAÇÕES GERAIS  -->        
        <div class="painel-dados" v-show="abaAtiva === 'informacoes'">
          
          <div class="secao-dados">
            <h2 class="secao-titulo">Dados Básicos</h2>
            <div class="grade-dados">
              
              <!-- LINHA 1: Nomes, Sigla, Tipo -->
              <div class="item-dado" v-if="colegiado.nome">
                <span class="item-rotulo">Nome</span>
                <span class="item-valor">{{ colegiado.nome }}</span>
              </div>
              
              <div class="item-dado" v-if="colegiado.sigla">
                <span class="item-rotulo">Sigla</span>
                <span class="item-valor">{{ colegiado.sigla }}</span>
              </div>

              <div class="item-dado" v-if="colegiado.tipo">
                <span class="item-rotulo">Tipo</span>
                <span class="item-valor" style="text-transform: capitalize;">{{ colegiado.tipo }}</span>
              </div>

              <!-- LINHA 2: Órgão, Status -->
              <div class="item-dado item-dado--medio">
                <span class="item-rotulo">Órgão</span>
                <span class="item-valor">{{ colegiado.orgao_nome }} <span v-if="colegiado.orgao_sigla">— {{ colegiado.orgao_sigla }}</span></span>
              </div>

              <div class="item-dado" v-if="colegiado.status">
                <span class="item-rotulo">Status</span>
                <span class="item-valor">{{ formatarStatus(colegiado.status) }}</span>
              </div>

              <!-- LINHA 3 (Condicional): Motivo Inativo (3/3) -->
              <div class="item-dado item-dado--largo" v-if="colegiado.status === 'inativo' && colegiado.status_motivo">
                <span class="item-rotulo">Motivo do status inativo</span>
                <span class="item-valor">{{ colegiado.status_motivo }}</span>
              </div>
              
            </div>
          </div>

          <div class="secao-dados">
            <h2 class="secao-titulo">Membros e Composição</h2>
            <!-- Adicionada a classe grade-dados--4 aqui -->
            <div class="grade-dados grade-dados--4">
                            
              <div class="item-dado">
                <span class="item-rotulo">Titulares Ativos</span>
                <span class="item-valor">{{ totalTitularesAtivos }}</span>
              </div>

              <div class="item-dado">
                <span class="item-rotulo">Suplentes Ativos</span>
                <span class="item-valor">{{ totalSuplentesAtivos }}</span>
              </div>

              <div class="item-dado" v-if="colegiado.quantidade_membros_titulares_minimo || colegiado.quantidade_membros_titulares_maximo">
                <span class="item-rotulo">Qtd. Membros Titulares</span>
                <span class="item-valor">
                  <span v-if="colegiado.quantidade_membros_titulares_minimo">Mín: {{ colegiado.quantidade_membros_titulares_minimo }}</span>
                  <span v-if="colegiado.quantidade_membros_titulares_minimo && colegiado.quantidade_membros_titulares_maximo"> | </span>
                  <span v-if="colegiado.quantidade_membros_titulares_maximo">Máx: {{ colegiado.quantidade_membros_titulares_maximo }}</span>
                </span>
              </div>

              <div class="item-dado" v-if="colegiado.quantidade_membros_suplentes_minimo || colegiado.quantidade_membros_suplentes_maximo">
                <span class="item-rotulo">Qtd. Membros Suplentes</span>
                <span class="item-valor">
                  <span v-if="colegiado.quantidade_membros_suplentes_minimo">Mín: {{ colegiado.quantidade_membros_suplentes_minimo }}</span>
                  <span v-if="colegiado.quantidade_membros_suplentes_minimo && colegiado.quantidade_membros_suplentes_maximo"> | </span>
                  <span v-if="colegiado.quantidade_membros_suplentes_maximo">Máx: {{ colegiado.quantidade_membros_suplentes_maximo }}</span>
                </span>
              </div>

              <!-- Linha 2 -->
              <div class="item-dado" v-if="colegiado.duracao_mandato">
                <span class="item-rotulo">Duração do mandato</span>
                <span class="item-valor">{{ colegiado.duracao_mandato }} anos</span>
              </div>

              <div class="item-dado" v-if="colegiado.intervalo_mandato">
                <span class="item-rotulo">Intervalo do mandato</span>
                <span class="item-valor">{{ colegiado.intervalo_mandato }} anos</span>
              </div>

              <div class="item-dado" v-if="colegiado.permite_reconducao !== null">
                <span class="item-rotulo">Permite recondução</span>
                <span class="item-valor">{{ colegiado.permite_reconducao ? 'Sim' : 'Não' }}</span>
              </div>

              <div class="item-dado" v-if="colegiado.permite_reconducao && colegiado.quantidade_reconducao !== null">
                <span class="item-rotulo">Qtd. de recondução</span>
                <span class="item-valor">{{ colegiado.quantidade_reconducao }}</span>
              </div>

            </div>
          </div>

          <div class="secao-dados">
            <h2 class="secao-titulo">Regras Específicas</h2>
            <div class="grade-dados grade-dados--4">
              <div class="item-dado" v-if="colegiado.cargo_presidente !== null">
                <span class="item-rotulo">Cargo de presidente em comissão</span>
                <span class="item-valor">{{ colegiado.cargo_presidente ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.lista_triplice !== null">
                <span class="item-rotulo">Lista tríplice</span>
                <span class="item-valor">{{ colegiado.lista_triplice ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.indicacao_governador !== null">
                <span class="item-rotulo">Indicação do governador</span>
                <span class="item-valor">{{ colegiado.indicacao_governador ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.nomeacao_governador !== null">
                <span class="item-rotulo">Nomeação via decreto</span>
                <span class="item-valor">{{ colegiado.nomeacao_governador ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.remunerado !== null">
                <span class="item-rotulo">Remunerado</span>
                <span class="item-valor">{{ colegiado.remunerado ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.remunerado && colegiado.valor_remunerado">
                <span class="item-rotulo">Valor remunerado</span>
                <span class="item-valor">{{ colegiado.valor_remunerado }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.referendar_nome !== null">
                <span class="item-rotulo">Referendar nomes</span>
                <span class="item-valor">{{ colegiado.referendar_nome ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.sabatina_alego !== null">
                <span class="item-rotulo">Sabatina da ALEGO</span>
                <span class="item-valor">{{ colegiado.sabatina_alego ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.presidente_indicado !== null">
                <span class="item-rotulo">Presidente indicado pelo Gov.</span>
                <span class="item-valor">{{ colegiado.presidente_indicado ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.membro_eleito !== null">
                <span class="item-rotulo">Membro eleito em assembleia</span>
                <span class="item-valor">{{ colegiado.membro_eleito ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.presidente_admin !== null">
                <span class="item-rotulo">Pres. é membro Cons. Admin.</span>
                <span class="item-valor">{{ colegiado.presidente_admin ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="item-dado" v-if="colegiado.continua_mandato !== null">
                <span class="item-rotulo">Continuidade no mandato</span>
                <span class="item-valor">{{ colegiado.continua_mandato ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>

          <div class="secao-dados">
            <h2 class="secao-titulo">Documentação e Observações</h2>
            <div class="grade-dados grade-dados--4">
              
              <!-- Regimento interno -->
              <div class="item-dado item-dado--largo" v-if="colegiado.regimento_interno !== null && colegiado.regimento_interno !== undefined && colegiado.regimento_interno !== ''">
                <span class="item-rotulo">Regimento interno</span>
                <span class="item-valor">
                  {{ colegiado.regimento_interno }}
                  <a v-if="colegiado.link_regimento_interno" :href="colegiado.link_regimento_interno" target="_blank" class="link-documento">Acessar Link do Regimento</a>
                </span>
              </div>

              <div class="item-dado item-dado--largo" v-if="colegiado.link_regimento_interno && !colegiado.regimento_interno">
                <span class="item-rotulo">Link do regimento interno</span>
                <span class="item-valor">
                  <a :href="colegiado.link_regimento_interno" target="_blank" rel="noopener noreferrer" class="link-documento" style="margin-left: 0;">{{ colegiado.link_regimento_interno }}</a>
                </span>
              </div>
              
              <!-- ARQUIVO UPLOAD -->
              <div class="item-dado item-dado--largo" v-if="colegiado.anexos && colegiado.anexos.length > 0">
                <span class="item-rotulo">Anexo do regimento interno</span>
                <span class="item-valor">
                  <a :href="urlPdf(colegiado.anexos[0].id)" target="_blank" rel="noopener noreferrer" class="link-documento" style="margin-left: 0;">
                    {{ colegiado.anexos[0].titulo || 'Ver Anexo' }}
                  </a>
                </span>
              </div>

              <!-- Legislação -->
              <div class="item-dado item-dado--largo" v-if="colegiado.legislacao !== null && colegiado.legislacao !== undefined && colegiado.legislacao !== ''">
                <span class="item-rotulo">Legislação</span>
                <span class="item-valor">
                  {{ colegiado.legislacao }}
                  <a v-if="colegiado.link_legislacao" :href="colegiado.link_legislacao" target="_blank" class="link-documento">Acessar Link da Legislação</a>
                </span>
              </div>
              
              <div class="item-dado item-dado--largo" v-if="colegiado.link_legislacao && !colegiado.legislacao">
                <span class="item-rotulo">Link da legislação</span>
                <span class="item-valor">
                  <a :href="colegiado.link_legislacao" target="_blank" rel="noopener noreferrer" class="link-documento" style="margin-left: 0;">{{ colegiado.link_legislacao }}</a>
                </span>
              </div>

              <!-- Representantes -->
              <div class="item-dado item-dado--largo" v-if="colegiado.representantes_sociedade !== null && colegiado.representantes_sociedade !== undefined && colegiado.representantes_sociedade !== ''">
                <span class="item-rotulo">Representantes da sociedade civil organizada</span>
                <span class="item-valor">{{ colegiado.representantes_sociedade }}</span>
              </div>
              
              <!-- Observação -->
              <div class="item-dado item-dado--largo" v-if="colegiado.observacao !== null && colegiado.observacao !== undefined && colegiado.observacao !== ''">
                <span class="item-rotulo">Observação</span>
                <span class="item-valor">{{ colegiado.observacao }}</span>
              </div>

            </div>
          </div>    
        </div>

        <!-- GUIA 2: MANDATOS  -->
         
        <div class="painel-dados" v-show="abaAtiva === 'mandatos'">
          <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
          
          <exibirMandatos v-if="mandatos" :mandatos="mandatos" :colegiado="colegiado" :permissoes="permissoes">
            
            <!-- INJETANDO O NOVO CARD DE DADOS BÁSICOS NO COMPONENTE FILHO -->
            <template slot="dados-basicos">
              <div class="secao-dados" style="margin-bottom: 1.15rem;">
                <h2 class="secao-titulo">Dados Básicos</h2>
                <div class="grade-dados">
                  
                  <div class="item-dado" v-if="colegiado.nome">
                    <span class="item-rotulo">Nome</span>
                    <span class="item-valor">{{ colegiado.nome }}</span>
                  </div>
                  
                  <div class="item-dado" v-if="colegiado.sigla">
                    <span class="item-rotulo">Sigla</span>
                    <span class="item-valor">{{ colegiado.sigla }}</span>
                  </div>

                  <div class="item-dado" v-if="colegiado.tipo">
                    <span class="item-rotulo">Tipo</span>
                    <span class="item-valor" style="text-transform: capitalize;">{{ colegiado.tipo }}</span>
                  </div>

                  <!-- Órgão  -->
                  <div class="item-dado">
                    <span class="item-rotulo">Órgão</span>
                    <span class="item-valor">{{ colegiado.orgao_nome }} <span v-if="colegiado.orgao_sigla">— {{ colegiado.orgao_sigla }}</span></span>
                  </div>

                  <!-- Titulares  -->
                  <div class="item-dado">
                    <span class="item-rotulo">Titulares: Ativos vs Limites</span>
                    <span class="item-valor">
                      <strong>{{ totalTitularesAtivos }}</strong> ativos
                      <span v-if="colegiado.quantidade_membros_titulares_minimo || colegiado.quantidade_membros_titulares_maximo">
                        — (Mín: {{ colegiado.quantidade_membros_titulares_minimo || '-' }} | Máx: {{ colegiado.quantidade_membros_titulares_maximo || '-' }})
                      </span>
                    </span>
                  </div>

                  <!-- Suplentes -->
                  <div class="item-dado">
                    <span class="item-rotulo">Suplentes: Ativos vs Limites</span>
                    <span class="item-valor">
                      <strong>{{ totalSuplentesAtivos }}</strong> ativos
                      <span v-if="colegiado.quantidade_membros_suplentes_minimo || colegiado.quantidade_membros_suplentes_maximo">
                        — (Mín: {{ colegiado.quantidade_membros_suplentes_minimo || '-' }} | Máx: {{ colegiado.quantidade_membros_suplentes_maximo || '-' }})
                      </span>
                    </span>
                  </div>
                  
                </div>
              </div>
            </template>

          </exibirMandatos>
        </div>
      </div>

      <!-- ================== MODAL DE EXCLUSÃO ================== -->
    <div v-if="modalExclusaoVisivel" class="modal-exclusao">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo excluir esse Colegiado?</h2>
          </div>
          <div class="modal-body">
            <p>Dados do Colegiado:</p>
            <div class="dados">
              <div class="flexbox">
                <div class="texto-centralizado">
                  Nome: <span>{{ colegiado.nome }}</span>
                </div>
                <div class="texto-centralizado">
                  Órgão: <span>{{ colegiado.orgao_id }}</span>
                </div>
                <div class="texto-centralizado">
                  Tipo: <span>{{ formatarTipo(colegiado.tipo) }}</span>
                </div>
                <div class="texto-centralizado">
                  Status: <span>{{ formatarStatus(colegiado.status) }}</span>
                </div>
              </div>
              <div class="flexbox">
                  <div class="texto-centralizado">
                      Quantidade de membros titulares mínimo: <span>{{ colegiado.quantidade_membros_titulares_minimo }}</span>
                  </div>
                  <div class="texto-centralizado">
                      Quantidade de membros suplentes mínimo: <span>{{ colegiado.quantidade_membros_suplentes_minimo }}</span>
                  </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                      Quantidade de membros titulares máximo: <span>{{ colegiado.quantidade_membros_titulares_maximo }}</span>
                  </div>
                  <div class="texto-centralizado">
                      Quantidade de membros suplentes máximo: <span>{{ colegiado.quantidade_membros_suplentes_maximo }}</span>
                  </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                  Regimento Interno: <span>{{ colegiado.regimento_interno}}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                    Motivo do Status Inativo:
                    <span v-if="colegiado.status === 'inativo'">{{ colegiado.status_motivo }}</span>
                    <span v-else>Não disponível</span>
                </div>
                <div class="texto-centralizado">
                    Link do Motivo do Status Inativo:
                    <span v-if="colegiado.status === 'inativo'">{{ colegiado.status_link_motivo || 'Não disponível' }}</span>
                    <span v-else>Não disponível</span>
                </div>
              </div>
              <div class="flexbox">
                  <div class="texto-centralizado">
                    Duração do mandato (anos): <span>{{ colegiado.duracao_mandato }}</span>
                  </div>
                  <div class="texto-centralizado">
                    Intervalo do mandato (anos): <span>{{ colegiado.intervalo_mandato }}</span>
                  </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                  Remunerado: <span>{{ colegiado.remunerado ? 'Sim' : 'Não' }}</span>
                </div>
                <div class="texto-centralizado">
                  Valor Remunerado:
                  <span v-if="colegiado.valor_remunerado">{{ colegiado.valor_remunerado }}</span>
                  <span v-else>Não aplicado</span>
                </div>
                <div class="texto-centralizado">
                  Referendar Nome: <span>{{ colegiado.referendar_nome ? 'Sim' : 'Não' }}</span>
                </div>
                <div class="texto-centralizado">
                  Sabatina Alego: <span>{{ colegiado.sabatina_alego ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                  Nomeação do Governador: <span>{{ colegiado.nomeacao_governador ? 'Sim' : 'Não' }}</span>
                </div>
                <div class="texto-centralizado">
                  Cargo de presidente nomeação em comissão: <span>{{ colegiado.cargo_presidente ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado ">
                  Lista Tríplice: <span>{{ colegiado.lista_triplice ? 'Sim' : 'Não' }}</span>
                </div>
                <div class="texto-centralizado">
                  Indicação do Governador: <span>{{ colegiado.indicacao_governador ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado ">
                  Permite Recondução: <span>{{ colegiado.permite_reconducao ? 'Sim' : 'Não' }}</span>
                </div>
                <div class="texto-centralizado">
                  Quantidade de recondução:
                    <span v-if="colegiado.permite_reconducao">{{ colegiado.quantidade_reconducao }}</span>
                    <span v-else>Não aplicado</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado ">
                  Legislação: <span>{{ colegiado.legislacao}}</span>
                </div>
                <div class="texto-centralizado">
                  Link Legislação:
                    <span v-if="colegiado.link_legislacao">{{ colegiado.link_legislacao }}</span>
                    <span v-else>Não disponível</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado ">
                  Representantes da sociedade civil organizada: <span>{{ colegiado.representantes_sociedade}}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                  Observação: <span>{{ colegiado.observacao}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
            <button class="btn-cancelar-exclusao" @click="modalExclusaoVisivel = false">Não</button>
          </div>
        </div>
      </div>
    <!-- ======================================================== -->
    </div>
    </div>

    <div class="form centro container-footer">
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="colegiado.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="colegiado.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="colegiado.created_at"
        :updated_at="colegiado.updated_at"
      />
    </div>

  </div>
</template>

<script>
import BotaoVoltar from "../BotaoVoltar.vue";
import ColegiadoApi from "../../services/ColegiadoApi";
import { parseISO } from "date-fns";
import Footer from "../Footer.vue";
import exibirMandatos from './ExibirMandato.vue';
import BaixarPdf from './BaixarPdf.vue';
import MsgErroFormularios from "../MsgErroFormularios";

export default {
  name: "ExibirColegiado",
  props: {
    colegiado: Object,
    mandatos: Array,
    permissoes: Object,
  },
  data() {
    return {
      abaAtiva: this.$route.query.aba === 'mandatos' ? 'mandatos' : 'informacoes',
      count: null,
      salvando: false,
      erro: false,
      erroSalvar: false,
      hasError: false,
      r: false,
      msgErros: null,
      orgaoResolvido: null,
      carregandoOrgao: false,
      modalExclusaoVisivel: false,
      dadosColegiados: {
        criado_por: null,
        atualizado_por: null,
        created_at: null,
        updated_at: null,
      },
    };
  },      
  computed: {
    orgaoParaPdf() {
      if (!this.colegiado || !this.colegiado.orgao_id) return null;
      const nome = this.colegiado.orgao_nome || '';
      const sigla = this.colegiado.orgao_sigla || '';
      return {
        id: this.colegiado.orgao_id,
        nome,
        sigla,
        label: `${nome} - ${sigla}`
      };
    },
    abaInicial() {
      return this.$route.query.aba === 'mandatos' ? 1 : 0;
    },
    totalTitularesAtivos() {
      if (!this.mandatos || !this.mandatos.length) return 0;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0); 
      return this.mandatos.filter(mandato => {            
        const isTitular = String(mandato.tipo_membro).toLowerCase() === 'titular' || mandato.tipo_membro == 1 || mandato.tipo_membro === '1';
        if (!isTitular) return false;
        if (!mandato.data_termino) return true; 
        const dataTermino = parseISO(mandato.data_termino);
        return dataTermino >= hoje; 
      }).length;
    },
    totalSuplentesAtivos() {
      if (!this.mandatos || !this.mandatos.length) return 0;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return this.mandatos.filter(mandato => {            
        const isSuplente = String(mandato.tipo_membro).toLowerCase() === 'suplente' || mandato.tipo_membro == 2 || mandato.tipo_membro === '2';
        if (!isSuplente) return false;
        if (!mandato.data_termino) return true;
        const dataTermino = parseISO(mandato.data_termino);
        return dataTermino >= hoje;
      }).length;
    }
  },
  created() {
    this.ColegiadoApi = new ColegiadoApi();
    this.resolverNomeOrgaoAsync();
  },
  watch: {
    colegiado: {
      handler() {
        this.resolverNomeOrgaoAsync();
      },
      immediate: true,
    }
  },
  components: {
    BotaoVoltar,
    Footer,
    exibirMandatos,
    BaixarPdf,
    MsgErroFormularios
  },
  methods: {
    urlPdf(anexo) {
      return `${process.env.VUE_APP_BASE_API_URL}/api/v1/colegiados/anexo/${anexo}`;
    },
    async excluirColegiado(colegiadoId) {
      if (!colegiadoId) return;

      const confirmacao = window.confirm("Deseja mesmo excluir esse Colegiado? Esta ação não poderá ser desfeita.");
      
      if (confirmacao) {
        try {
          if (!this.ColegiadoApi) {
             this.ColegiadoApi = new ColegiadoApi();
          }

          if (this.ColegiadoApi.cancelTokens && this.ColegiadoApi.cancelTokens.destroyColegiado) {
            this.ColegiadoApi.cancelTokens.destroyColegiado.cancel();
          }

          await this.ColegiadoApi.destroyColegiado(colegiadoId);
          this.$router.push({ name: "Colegiado" }); 
          
        } catch (err) {
          if (this.ColegiadoApi.isCancel && this.ColegiadoApi.isCancel(err)) {
            return;
          }
          this.erro = true;
          this.msgErros = {
            default: "Não foi possível excluir este colegiado, pois ele está vinculado a alguma outra entidade."
          };
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    },
    formatarTipo(valor) {
      if (valor === 'conselho') return 'Conselho';
      if (valor === 'comite') return 'Comitê';
      if (valor === 'forum') return 'Fórum';
      if (valor === 'diretoria') return 'Diretoria';
      if (valor === 'camara') return 'Câmara';
      if (valor === 'colegio') return 'Colégio';
      if (valor === 'junta') return 'Junta';
      return valor; 
    },
    async confirmarExclusao() {
      try {
        if (!this.ColegiadoApi) this.ColegiadoApi = new ColegiadoApi();
        if (this.ColegiadoApi.cancelTokens && this.ColegiadoApi.cancelTokens.destroyColegiado) {
          this.ColegiadoApi.cancelTokens.destroyColegiado.cancel();
        }

        await this.ColegiadoApi.destroyColegiado(this.colegiado.id);
        this.$router.push({ name: "Colegiados" }); 
      } catch (err) {
        if (this.ColegiadoApi.isCancel && this.ColegiadoApi.isCancel(err)) return;
        
        this.modalExclusaoVisivel = false;
        this.erro = true;
        this.msgErros = { 
          colegiado: "Não foi possível excluir este colegiado, pois ele está vinculado a alguma outra entidade." 
        };
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    formatarStatus(valor) {
      if (valor === 'em_estruturacao') return 'Em estruturação';
      if (valor === 'ativo') return 'Ativo';
      if (valor === 'inativo') return 'Inativo';
      return valor; 
    },    
    fecharErro() {
      this.erro = false;
    },
    async resolverNomeOrgaoAsync() {
      if (!this.colegiado || this.orgaoResolvido) return;
      const orgaoId = this.colegiado.orgao_id;
      if (!orgaoId || this.carregandoOrgao) return;
      if (!this.ColegiadoApi) this.ColegiadoApi = new ColegiadoApi();
      try {
        this.carregandoOrgao = true;
        const resposta = await this.ColegiadoApi.getOrgao();
        const listaOrgaos = Array.isArray(resposta) ? resposta : (resposta?.data || []);
        const orgaoEncontrado = listaOrgaos.find(item => String(item.id) === String(orgaoId));
        if (orgaoEncontrado) {
          this.$set(this.colegiado, 'orgao_nome', orgaoEncontrado.nome);
          this.$set(this.colegiado, 'orgao_sigla', orgaoEncontrado.sigla);
        }
      } catch (erro) {
        console.error('Erro ao resolver o órgão:', erro);
      } finally {
        this.carregandoOrgao = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* ESTILOS GERAIS DA PÁGINA */
.fora {
  box-sizing: border-box;
  width: 100% !important; 
  max-width: 100% !important;  
  padding: 1rem 3rem 1.5rem !important; 
  margin: 0 !important; 
  background-color: transparent !important; 
  min-height: calc(100vh - 10rem);
}

.topo-header {
  margin: 0 0 1rem 0;
  padding: 0;
  display: flex;
  align-items: center; 
  justify-content: space-between; 

  ::v-deep h1 {
    margin-left: 0.75rem;
    font-family: "Montserrat-Medium";
    font-weight: bold;
    color: #ffa600;
    font-size: 1.8rem;
    height: 1rem;
    line-height: 1.5rem; 
  }

  /* BLOCO MOVIDO PARA DENTRO DE TOPO-HEADER */
  .acoes-topo {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    .btn-acao {
      font-family: "Montserrat-Medium", sans-serif;
      font-size: 0.9rem;
      padding: 0.2rem 1rem;
      border-radius: 0.2rem;
      cursor: pointer;
      background: transparent;
      transition: 0.2s;
    }

    .btn-editar {
      color: #005516;
      border: #005516 solid 0.15rem;
    }

    .btn-editar:hover {
      color: white;
      background-color: #005516;
    }

    .btn-excluir {
      color: #d32f2f;
      border: #d32f2f solid 0.15rem;
    }

    .btn-excluir:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}
   

.form.centro,
.centro {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* NAVEGAÇÃO DAS ABAS */
.abas {
  display: flex;
  gap: 0.15rem;
  margin: 0 0 1.15rem 0;
  border-bottom: 1px solid #d7e0d9;
  padding: 0 0.15rem;

  .aba {
    border: none;
    background: transparent;
    color: #3d5c45;
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 1.05rem;
    padding: 0.55rem 1.1rem 0.65rem;
    cursor: pointer;
    border-bottom: 0.2rem solid transparent;
    margin-bottom: -1px;
    transition: color 0.15s ease, border-color 0.15s ease;
  }

  .aba:hover {
    color: #005516;
  }

  .aba.ativa {
    color: #005516;
    border-bottom-color: #ffa600;
    font-family: "Montserrat-Bold", sans-serif;
  }
}

.conteudo-abas {
  min-height: 8rem;
}
/* CONTAINER ABAS E AÇÕES NO TOPO */
.container-abas-topo {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #d7e0d9;
  margin: 0 0 1.15rem 0;
  padding: 0 0.15rem;
  
  .abas {
    border-bottom: none;
    margin: 0;
    padding: 0;
  }  
}

/* Ajuste simples para não quebrar em telas de celular */
@media screen and (max-width: 700px) {
  .container-abas-topo {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    border-bottom: none;

    .acoes-topo {
      margin-bottom: 1rem;
    }
  }
}

.painel-dados {
  display: grid;
  gap: 0.85rem;
}

.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

.secao-titulo {
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.4rem 0;
  border-bottom: 1px solid #e2eae4;
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 1rem; 
  color: #0a4a22;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.grade-dados {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem 0.65rem; 
}

.item-dado {
  min-width: 0;
  padding: 0.4rem 0.6rem; 
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.4rem; 
}

.item-dado--largo {
  grid-column: 1 / -1;
}

.item-dado--medio {
  grid-column: span 2;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.15rem 0; 
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem; 
  line-height: 1.2;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.90rem; 
  line-height: 1.3;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

/*  BOTÕES DE AÇÃO */
.bt-editar {
  text-align: center;
  margin: 1.5rem 0 2rem 0;

  .div-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.35rem;
  }

  button {
    background-color: #005516;
    color: white;
    border: none;
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 1rem;
    padding: 0.4rem 2rem;
    border-radius: 2rem;
    margin: 0.2rem;
    cursor: pointer;
  }

  button:hover {
    background-color: #4caf50;
  }
}

/* RESPONSIVIDADE */
@media screen and (max-width: 900px) {
  .fora {
    padding: 0.9rem 0 1.35rem !important;
  }
  .grade-dados {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 700px) {
  .fora {
    padding: 0.85rem 0 1.25rem !important;
  }
  .topo-header ::v-deep h1 {
    font-size: 1.35rem;
    margin-left: 0.5rem;
  }
  .abas {
    padding: 0;
    gap: 0;
    overflow-x: auto;
    
    .aba {
      flex: 1 0 auto;
      text-align: center;
      padding-left: 0.45rem;
      padding-right: 0.45rem;
      font-size: 0.82rem;
      white-space: nowrap;
    }
  }
  .secao-dados {
    padding: 0.95rem 0.9rem 1rem;
  }
  .grade-dados {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }
  .item-dado--largo, .item-dado--medio {
    grid-column: auto;
  }
}
.grade-dados--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media screen and (max-width: 1065px) {
  .grade-dados--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 700px) {
  .grade-dados--4 {
    grid-template-columns: 1fr;
  }
}
/* ESTILOS DO MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 60%; 
    max-height: 90vh; 
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column; 
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header h2 {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: center;
      margin-top: 1rem;
      flex-shrink: 0;
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto;
      flex-grow: 1;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;
        
        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr; 
          gap: 0.5rem 1.5rem; 
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word; 
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/* Responsividade do Modal para telas menores */
@media screen and (max-width: 900px) {
  .modal-exclusao .modal-mask {
    width: 85%;
  }
}
@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
  
  /* Retorna para 1 coluna em telas de celular */
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}

/* ALINHAMENTO E ESPAÇAMENTO DO FOOTER */
.fora .container-footer {
  margin-top: 1.5rem !important; 
  margin-bottom: 2rem !important;
  padding: 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 0 !important;
  display: flex !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;

  /* Entra dentro do componente Footer */
  ::v-deep * {
    height: auto !important;
    min-height: 0 !important;
  }

  ::v-deep .footer-container,
  ::v-deep > div {
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    text-align: left !important;
  }

  ::v-deep p {
    text-align: left !important;
    margin: 0 0 0.5rem 0 !important;
    padding: 0 !important;
  }
}
</style>